/**
 * A fixing placed on the hold. Position is stored in the x/z footprint; its
 * surface point and best-fit angle are resolved from the current sculpted
 * field. This lets a screw pivot with a curved face while still reaching the
 * flat rear mounting plane.
 *
 * `typeId` indexes FIXING_TYPES in the config. V1 ships one countersunk screw;
 * bolt holes, washer recesses and other standards drop in as extra entries
 * without touching this model.
 */
export interface Fixing {
  readonly id: string;
  readonly typeId: string;
  /** Footprint position, mm. */
  readonly x: number;
  readonly z: number;
}

export function createFixingId(): string {
  return `fix_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
}
